
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.ChatContainer_c7f80ffe7b7e5659{transform:rotate(270deg)}.ChatContainer_c7f80ffe7b7e5659,.ChatNetspendContainer_7d60891a9f2d7b6c{cursor:pointer;position:fixed;bottom:40vh;right:-16px;z-index:1}.ChatDesktopIcon_e7e195ac5f5d7b4f,.ChatNetspendDesktopIcon_54eb1dc26471133c{display:none}.ChatMobileIcon_24e8fbdf2b811cc6{display:block}.ChatNetspendMobileIcon_49e7afc49105ede0{cursor:pointer;position:fixed;bottom:10px;right:10px;width:40px;height:40px;background-color:#ff6b00;border:none;z-index:10000;border-radius:50%;box-shadow:0 2px 9pt 0 rgba(64,64,64,.2);padding:0;display:flex;align-items:center;justify-content:center}@media (min-width:600px){.ChatContainer_c7f80ffe7b7e5659{transform:none;bottom:20px;right:30px}.ChatMobileIcon_24e8fbdf2b811cc6,.ChatNetspendMobileIcon_49e7afc49105ede0{display:none}.ChatDesktopIcon_e7e195ac5f5d7b4f{display:block}.ChatNetspendDesktopIcon_54eb1dc26471133c{cursor:pointer;position:fixed;bottom:10px;right:10px;width:52px;height:52px;background-color:#ff6b00;border:none;z-index:10000;border-radius:50%;box-shadow:0 2px 9pt 0 rgba(64,64,64,.2);padding:0;display:flex;align-items:center;justify-content:center}}`;
styleInject(_css)

/** ChatContainer Props */
export type ChatContainerCCM = {
  /** ChatContainer Component Custom Properties */
  // No custom properties found

  /** ChatContainer Modifier Flags */
  // No modifiers classes found
};
/** Base ChatContainer component */
export const ChatContainer: ComponentCreator<ChatContainerCCM> = createComponentCreator({
  "name": "ChatContainer",
  "base": "ChatContainer_c7f80ffe7b7e5659",
  "prop": {},
  "mod": {}
});


/** ChatNetspendContainer Props */
export type ChatNetspendContainerCCM = {
  /** ChatNetspendContainer Component Custom Properties */
  // No custom properties found

  /** ChatNetspendContainer Modifier Flags */
  // No modifiers classes found
};
/** Base ChatNetspendContainer component */
export const ChatNetspendContainer: ComponentCreator<ChatNetspendContainerCCM> = createComponentCreator({
  "name": "ChatNetspendContainer",
  "base": "ChatNetspendContainer_7d60891a9f2d7b6c",
  "prop": {},
  "mod": {}
});


/** ChatDesktopIcon Props */
export type ChatDesktopIconCCM = {
  /** ChatDesktopIcon Component Custom Properties */
  // No custom properties found

  /** ChatDesktopIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ChatDesktopIcon component */
export const ChatDesktopIcon: ComponentCreator<ChatDesktopIconCCM> = createComponentCreator({
  "name": "ChatDesktopIcon",
  "base": "ChatDesktopIcon_e7e195ac5f5d7b4f",
  "prop": {},
  "mod": {}
});


/** ChatNetspendDesktopIcon Props */
export type ChatNetspendDesktopIconCCM = {
  /** ChatNetspendDesktopIcon Component Custom Properties */
  // No custom properties found

  /** ChatNetspendDesktopIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ChatNetspendDesktopIcon component */
export const ChatNetspendDesktopIcon: ComponentCreator<ChatNetspendDesktopIconCCM> = createComponentCreator({
  "name": "ChatNetspendDesktopIcon",
  "base": "ChatNetspendDesktopIcon_54eb1dc26471133c",
  "prop": {},
  "mod": {}
});


/** ChatMobileIcon Props */
export type ChatMobileIconCCM = {
  /** ChatMobileIcon Component Custom Properties */
  // No custom properties found

  /** ChatMobileIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ChatMobileIcon component */
export const ChatMobileIcon: ComponentCreator<ChatMobileIconCCM> = createComponentCreator({
  "name": "ChatMobileIcon",
  "base": "ChatMobileIcon_24e8fbdf2b811cc6",
  "prop": {},
  "mod": {}
});


/** ChatNetspendMobileIcon Props */
export type ChatNetspendMobileIconCCM = {
  /** ChatNetspendMobileIcon Component Custom Properties */
  // No custom properties found

  /** ChatNetspendMobileIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ChatNetspendMobileIcon component */
export const ChatNetspendMobileIcon: ComponentCreator<ChatNetspendMobileIconCCM> = createComponentCreator({
  "name": "ChatNetspendMobileIcon",
  "base": "ChatNetspendMobileIcon_49e7afc49105ede0",
  "prop": {},
  "mod": {}
});

